import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { ArrowRight } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const specialtySlug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default function SpecialtiesIndex() {
  const [specs, setSpecs] = useState([]);
  useEffect(() => {
    axios.get(`${API}/specialties`).then((r) => setSpecs(r.data.specialties || [])).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-surface" data-testid="specialties-index-page">
      <Navbar />
      <main className="pt-28 pb-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <h1 className="font-spectral text-4xl sm:text-5xl font-bold text-primary mb-4">Specialties we review</h1>
        <p className="text-secondary max-w-2xl mb-10">Choose a specialty to see what gets reviewed, which reports to upload and who reviews your case.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {specs.map((s) => (
            <Link
              key={s}
              to={`/specialties/${specialtySlug(s)}`}
              className="group flex items-center justify-between px-5 py-4 rounded-xl bg-surface-secondary border border-primary/10 hover:border-primary/40 transition-colors"
              data-testid={`specialty-link-${specialtySlug(s)}`}
            >
              <span className="text-primary font-medium">{s}</span>
              <ArrowRight size={16} className="text-primary group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
